import { Data } from '@strapi/strapi';

export type StrapiResponse<T> = Promise<{
  data: T;
}>;

export type HomeData = {
  homePage: Data.ContentType<'api::home-page.home-page'>;
  sectionFeatureOne: Data.ContentType<'api::section-feature-one.section-feature-one'>;
  sectionFeatureTwo: Data.ContentType<'api::section-feature-two.section-feature-two'>;
  sectionFeatureThree: Data.ContentType<'api::section-feature-three.section-feature-three'>;
  sectionFeatureFour: Data.ContentType<'api::section-feature-four.section-feature-four'>;
  sectionHeaderOne: Data.ContentType<'api::section-header-one.section-header-one'>;
  sectionFaq: Data.ContentType<'api::section-faq.section-faq'>;
  sectionTestimonial: Data.ContentType<'api::section-testimonial.section-testimonial'>;
};

export type PricingData = {
  pricingPage: Data.ContentType<'api::pricing-page.pricing-page'>;
  sectionPlanHero: Data.ContentType<'api::section-plan-hero.section-plan-hero'>;
  sectionPlan: Data.ContentType<'api::section-plan.section-plan'>;
  sectionTestimonial: Data.ContentType<'api::section-testimonial.section-testimonial'>;
  sectionPricingFaq: Data.ContentType<'api::section-pricing-faq.section-pricing-faq'>;
  sectionTrust: Data.ContentType<'api::section-trust.section-trust'>;
};

export type FooterData = {
  sectionFooter: Data.ContentType<'api::section-footer.section-footer'>;
};

export type NavigationData = {
  navigation: Data.ContentType<'api::navigation.navigation'>;
};

export type HomeHeroData = {
  sectionHomeHero: Data.ContentType<'api::section-home-hero.section-home-hero'>;
};

export type TermSheetData = {
  termSheetLanding: Data.ContentType<'api::term-sheet-landing.term-sheet-landing'>;
};

export type AboutData = {
  about: Data.ContentType<'api::about.about'>;
};

export type ProductOriginationData = {
  productOriginationPage: Data.ContentType<'api::product-origination-page.product-origination-page'>;
  sectionTestimonial: Data.ContentType<'api::section-testimonial.section-testimonial'>;
  sectionFaq: Data.ContentType<'api::section-faq.section-faq'>;
};

export type ProductServicingData = {
  productServicingPage: Data.ContentType<'api::product-servicing-page.product-servicing-page'>;
  sectionTestimonial: Data.ContentType<'api::section-testimonial.section-testimonial'>;
  sectionFaq: Data.ContentType<'api::section-faq.section-faq'>;
};

export type ToolsCalculatorsData = {
  sectionToolsAndCalculators: Data.ContentType<'api::section-tools-and-calculators.section-tools-and-calculators'>;
};

export type ContactData = {
  contactPage: Data.ContentType<'api::contact-page.contact-page'>;
  sectionTestimonial: Data.ContentType<'api::section-testimonial.section-testimonial'>;
  sectionFaq: Data.ContentType<'api::section-faq.section-faq'>;
};

export type CareersData = {
  careersPage: Data.ContentType<'api::careers-page.careers-page'>;
};

export type CaseStudyData = {
  caseStudy: Data.ContentType<'api::case-study.case-study'>;
};

export type CalculatorData = {
  calculators: Data.ContentType<'api::calculator.calculator'>[];
};

export type ArticleData = {
  article: Data.ContentType<'api::article.article'>;
};

type ResourceFeature = Data.Component<'shared.resource-feature'>;

export type CustomCardResource = Pick<
  ResourceFeature,
  'id' | 'custom_cover' | 'custom_alt_text' | 'custom_title' | 'custom_link'
> & {
  resource_type: 'custom';
};

export type CardResource =
  | ArticleData['article']
  | CaseStudyData['caseStudy']
  | Data.ContentType<'api::calculator.calculator'>
  | CustomCardResource;

// Predicate: the generated type marks `header` optional, so inline `'header' in x` won't narrow.
export const isCalculatorResource = (
  resource: CardResource
): resource is Data.ContentType<'api::calculator.calculator'> =>
  'header' in resource;

export const isCustomResource = (
  resource: CardResource
): resource is CustomCardResource =>
  'resource_type' in resource && resource.resource_type === 'custom';

export type ProductPageData = {
  productPage: Data.ContentType<'api::product-page.product-page'>;
};

export type LegalPagesData = {
  legalPages: Data.ContentType<'api::legal-page.legal-page'>[];
};

export type ResourcePageData = {
  resourcePage: Data.ContentType<'api::resource-page.resource-page'>;
};

export type GlobalData = {
  global: Data.ContentType<'api::global.global'>;
};

export type FaqPageData = {
  faqPage: Data.ContentType<'api::faq-page.faq-page'>;
};
